import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsGraphAddTool;
(function (NsGraphAddTool) {
    /** Command: 用于注册named factory */
    NsGraphAddTool.command = XFlowGraphCommands.GRAPH_ADD_TOOL;
    /** hookName */
    NsGraphAddTool.hookKey = 'addTool';
})(NsGraphAddTool || (NsGraphAddTool = {}));
let GraphAddToolCommand = 
/** 创建节点命令 */
class GraphAddToolCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.addTool.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { cellId, toolConfig, commandService } = handlerArgs;
                const graph = yield ctx.getX6Graph();
                const cell = graph.getCellById(cellId);
                if (cell) {
                    cell.addTools(toolConfig.items, toolConfig.options);
                    ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        if (Array.isArray(toolConfig.items)) {
                            toolConfig.items.forEach(item => {
                                commandService.executeCommand(XFlowGraphCommands.GRAPH_DEL_TOOL.id, {
                                    cellId,
                                    toolname: item,
                                });
                            });
                        }
                    })));
                }
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphAddToolCommand.prototype, "contextProvider", void 0);
GraphAddToolCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphAddTool.command.id },
    })
    /** 创建节点命令 */
], GraphAddToolCommand);
export { GraphAddToolCommand };
//# sourceMappingURL=graph-add-tool.js.map